// packages/shared-hooks/src/leads/useTransitionLeadStage.ts
//
// `PATCH /leads/:id/stage` — request stage move. Server enforces the v1
// graph (active → any, terminal → no-exit) and the paid-requires-client
// invariant; UI must surface backend errors via the typed code/message.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  LeadListItemSchema,
  type LeadListItem,
  type TransitionLeadStageInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useTransitionLeadStage(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<LeadListItem, unknown, TransitionLeadStageInput>({
    mutationFn: (input) =>
      client.patch<LeadListItem>(`/leads/${id}/stage`, input, {}, LeadListItemSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadsKeys.all });
      void qc.invalidateQueries({ queryKey: leadsKeys.detail(id) });
    },
  });
}
